/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import SmsTemplatesidSmsTemplate from './SmsTemplatesidSmsTemplate';

/**
 * The SmsTemplatesIdBody model module.
 * @module model/SmsTemplatesIdBody
 * @version v0.3
 */
export default class SmsTemplatesIdBody {
  /**
   * Constructs a new <code>SmsTemplatesIdBody</code>.
   * @alias module:model/SmsTemplatesIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SmsTemplatesIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SmsTemplatesIdBody} obj Optional instance to populate.
   * @return {module:model/SmsTemplatesIdBody} The populated <code>SmsTemplatesIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SmsTemplatesIdBody();
      if (data.hasOwnProperty('sms_template'))
        obj.smsTemplate = SmsTemplatesidSmsTemplate.constructFromObject(data['sms_template']);
    }
    return obj;
  }
}

/**
 * @member {module:model/SmsTemplatesidSmsTemplate} smsTemplate
 */
SmsTemplatesIdBody.prototype.smsTemplate = undefined;

